import React, { useState } from "react";
import { Modal, Typography, Box, Backdrop, Button, Paper } from "@mui/material";
import { API, graphqlOperation } from "aws-amplify";
import { deleteItemmaster, updateItemmaster } from "../../graphql/mutations";
import { useNavigate } from "react-router-dom";
import { showErrorSnackbar, showSuccessSnackbar } from "../snackBar/snakbar";
import { useThemes } from "../Theme/theme";
import { useSelector } from "react-redux";
import { createItemMaster } from "../../graphql";
import { LoadingButton } from "@mui/lab";
import CloseIcon from '@mui/icons-material/Close';

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: 24,
  outline: "none",
  borderRadius: "4px",
  "@media (min-width:600px)": {
    width: "auto",
  },
  width: "90%",
};

const ItemActiveOrInActiveModal = ({
  open,
  text,
  setFn,
  setOpen,
  editData,
  action,
  setRows,
  rows,
  onComplete
}) => {
  const { theme } = useThemes();

  const [loading, setLoading] = useState(false);
  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setOpen(false);
    }
    if (setFn) {
      setFn();
    }
  };
  let getCompany = useSelector(
    (state) => state?.companyReducer?.companyDetails
  );
  const userPreferenceAndFY = useSelector(
    (state) => state.userPrefrenceandReducer
  );
  async function markAsInActive() {
    try {
      setLoading(true)
      let obj = editData;
      const comments =
        typeof obj.remarks === "string" ? obj.remarks.split("\n") : [];
      const purchaseFlag = obj.purchaseInvoiceFlag;
      const invoiceFlag = obj.salesInvoiceFlag;
      let masterData = {
        // ComapnyID: "10001",
        currencycd: "13",
        hsnid: obj?.hsnCode?.value,
        itemid: obj.itemId,
        itemcategorycd: obj.itemCtegorey === "" ? 0 : obj.itemCtegorey,
        itemcode: obj?.itemCode,
        itemname: obj?.itemName,
        itemtype: obj?.type === 1 ? "GOODS" : "SERVICE",
        measurementcd: obj.unit,
        purchaseaccountid: purchaseFlag === 0 ? 0 : obj.purchaseAccount?.value,
        purchaseinvoiceflag: purchaseFlag,
        reversechargeflag: 0,
        salesaccountid: invoiceFlag === 0 ? 0 : obj.salesAccount?.value,
        salesinvoiceflag: invoiceFlag,
        taxabilitycd: obj?.taxability.value,
        is_active: obj?.Is_Active == 1 ? 0 : 1,
        serialnumber: obj?.voucherSeries?.value,
        description: comments?.join("**"),
        expiredtimestamp: 0,
        lastupdatedby: "",
        financialyearid: userPreferenceAndFY?.financialYear?.financialyearid,
        companyid: getCompany?.companyid,
      };

      let response = await API.graphql(
        graphqlOperation(createItemMaster, {
          createItemMasterInput: masterData,
        })
      );
      if (response.data.createItemTransaction !== null) {
        handleClose();
        setLoading(false)
        let temprows = JSON.parse(JSON.stringify(rows));
        temprows = [
          ...temprows.map((elem) => {
            if (elem.itemId == obj.itemId) {
              return { ...elem, Is_Active: elem.Is_Active == 0 ? 1 : 0 };
            } else {
              return elem;
            }
          }),
        ];

        setRows([...temprows]);

        showSuccessSnackbar(
          `Item marked as ${obj.Is_Active == 0 ? "active" : "inactive"}`
        );
        if (typeof onComplete === "function") {
          onComplete();
        }
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
      const rawMessage = error.errors[0].message.split("RDSHttp:")[1];
      const parsedMessage = JSON.parse(rawMessage).message;
      const errorMessage = parsedMessage.split("ERROR: ")[1].split(";")[0];
      showErrorSnackbar(errorMessage);
    }
  }
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      {/* <Fade in={open}> */}
      <Paper sx={style}>

        <Box sx={{display:"flex",justifyContent:"flex-end",padding:"10px",backgroundColor:theme.palette.primary.main,borderTopLeftRadius:"4px",borderTopRightRadius:"4px"}}>
            <CloseIcon fontSize="10px" sx={{color:"white",cursor:"pointer"}} onClick={handleClose}/>
        </Box>
        <Box
          sx={{
            borderRadius: "4px",
            padding: "15px",
            textAlign: "center",
            overflowY: { xs: "scroll", sm: "hidden" },
            ".MuiTableCell-root": {
              padding: "10px 10px",
              fontSize: "13px",
            },
          }}
        >
          <Typography
            sx={{
              color: theme?.palette?.TmId.id.toString().includes("9")
                ? ""
                : "rgb(60 60 60)",
              fontWeight: "bold",
            }}
          >
            Do you want to Make the {text}{" "}
            {editData?.Is_Active == 0 ? "Active" : "InActive"}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            // flexDirection: { xs: 'column', sm: 'row' },
            paddingLeft: "15px",
            paddingRight: "15px",
            paddingBottom: "15px",
          }}
        >
          <Button
            onClick={handleClose}
            variant="outlined"
            sx={{ flex: 1, margin: "5px", fontSize: "12px" }}
          >
            No
          </Button>
          <LoadingButton
            color="info"
            sx={{ flex: 1, margin: "5px", fontSize: "12px" }}
            loading={loading}
            disableRipple={true}
            variant="contained"
            onClick={markAsInActive}
          >
            Yes
          </LoadingButton>
        </Box>
      </Paper>
      {/* </Fade> */}
    </Modal>
  );
};

export default ItemActiveOrInActiveModal;
